/* Filtres, tri et « Voir plus » des pages collection et recherche.
   Rendu côté serveur via la Section Rendering API. */
(() => {
  'use strict';
  const { $, $$, openModal } = window.LRDF;

  function init(root) {
    if (!root || root.dataset.facetsReady) return;
    root.dataset.facetsReady = 'true';
    const sectionId = root.dataset.sectionId;
    let controller;

    const fetchSection = async (url) => {
      if (controller) controller.abort();
      controller = new AbortController();
      const u = new URL(url, window.location.origin);
      u.searchParams.set('section_id', sectionId);
      const res = await fetch(u, { signal: controller.signal });
      return new DOMParser().parseFromString(await res.text(), 'text/html');
    };

    const swap = (doc, selector) => {
      const fresh = $(selector, doc);
      const current = $(selector, root);
      if (fresh && current) current.replaceWith(fresh);
    };

    async function update(url, { keepDrawer = false } = {}) {
      const results = $('[data-results]', root);
      if (results) results.classList.add('is-loading');
      try {
        const doc = await fetchSection(url);
        const clean = new URL(url, window.location.origin);
        clean.searchParams.delete('section_id');
        history.replaceState({}, '', clean.pathname + clean.search);

        swap(doc, '[data-toolbar]');
        swap(doc, '[data-results]');
        swap(doc, '[data-collection-count]');
        const drawer = $('[data-filters-drawer]', root);
        if (keepDrawer && drawer && !drawer.hidden) {
          // Le tiroir reste ouvert : on remplace son contenu en conservant le focus.
          const active = document.activeElement;
          const key = active && active.name ? `${active.name}::${active.value}` : null;
          const freshBody = $('[data-filters-form]', doc);
          const freshFoot = $('.filters__footer', doc);
          if (freshBody) $('[data-filters-form]', drawer).innerHTML = freshBody.innerHTML;
          if (freshFoot) $('.filters__footer', drawer).innerHTML = freshFoot.innerHTML;
          if (key) {
            const [name, value] = key.split('::');
            const target = $$('[data-filters-form] [name]', drawer).find((n) => n.name === name && n.value === value);
            if (target) target.focus({ preventScroll: true });
          }
        } else {
          swap(doc, '[data-filters-drawer]');
        }
        window.LRDF.Wishlist.sync();
      } catch (err) {
        if (err.name !== 'AbortError') window.location.href = url;
      }
    }

    const formUrl = () => {
      const form = $('[data-filters-form]', root);
      const params = new URLSearchParams(new FormData(form));
      const sort = $('[data-sort]', root);
      if (sort) params.set('sort_by', sort.value);
      return `${window.location.pathname}?${params.toString()}`;
    };

    root.addEventListener('change', (e) => {
      if (e.target.matches('[data-sort]')) {
        update(formUrl());
      } else if (e.target.closest('[data-filters-form]') && !e.target.matches('[data-price-range]')) {
        update(formUrl(), { keepDrawer: true });
      }
    });

    let priceTimer;
    root.addEventListener('input', (e) => {
      if (!e.target.matches('[data-price-range]')) return;
      const range = e.target;
      const hidden = $('[data-price-input]', range.parentElement);
      $('[data-price-output]', range.parentElement).textContent = `${range.value} €`;
      const atMax = Number(range.value) >= Number(range.max);
      hidden.disabled = atMax;
      hidden.value = range.value;
      clearTimeout(priceTimer);
      priceTimer = setTimeout(() => update(formUrl(), { keepDrawer: true }), 350);
    });

    root.addEventListener('click', async (e) => {
      const opener = e.target.closest('[data-filters-open]');
      if (opener) {
        openModal($('[data-filters-drawer]', root));
        return;
      }
      const link = e.target.closest('[data-facet-link]');
      if (link) {
        e.preventDefault();
        update(link.href, { keepDrawer: true });
        return;
      }
      const more = e.target.closest('[data-load-more]');
      if (more) {
        e.preventDefault();
        more.setAttribute('aria-busy', 'true');
        try {
          const doc = await fetchSection(more.href);
          const grid = $('[data-grid]', root);
          $$('[data-grid] > *', doc).forEach((card) => grid.append(card));
          swap(doc, '[data-pagination]');
          window.LRDF.Wishlist.sync();
        } catch (err) {
          window.location.href = more.href;
        }
      }
    });
  }

  const boot = () => $$('[data-facets]').forEach(init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();
